import { render, staticRenderFns } from "./InsurancePayerDetail.vue?vue&type=template&id=67be483e"
import script from "./InsurancePayerDetail.vue?vue&type=script&lang=js"
export * from "./InsurancePayerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports